import * as React from 'react'

const SvgRatioIcon = (props) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_3890_88248)">
      <path
        d="M0.769531 14.2083C0.769531 16.9772 3.02239 19.2301 5.79132 19.2301H14.2093C16.9782 19.2301 19.2311 16.9772 19.2311 14.2083V5.78959C19.2311 3.02066 16.9782 0.768555 14.2093 0.768555H5.79132C3.02239 0.768555 0.769531 3.02066 0.769531 5.78959V14.2083ZM2.30799 5.78959C2.30799 3.86952 3.87049 2.30702 5.79132 2.30702H14.2093C16.1301 2.30702 17.6926 3.86952 17.6926 5.78959V14.2083C17.6926 16.1291 16.1301 17.6916 14.2093 17.6916H5.79132C3.87049 17.6916 2.30799 16.1291 2.30799 14.2083V5.78959Z"
        fill="white"
      />
      <path
        d="M7.10867 14.8795C7.47194 15.0943 7.94513 14.9776 8.16261 14.6098L13.1611 6.17303C13.3775 5.80719 13.2573 5.33544 12.8914 5.11909C12.5256 4.90275 12.0538 5.02369 11.8375 5.38877L6.83899 13.8255C6.62264 14.1914 6.74284 14.6631 7.10867 14.8795Z"
        fill="white"
      />
      <path
        d="M6.15437 10.297C7.42691 10.297 8.46206 9.26187 8.46206 7.98933C8.46206 6.7168 7.42691 5.68164 6.15437 5.68164C4.88184 5.68164 3.84668 6.7168 3.84668 7.98933C3.84668 9.26187 4.88184 10.297 6.15437 10.297ZM6.15437 7.2201C6.5788 7.2201 6.9236 7.5649 6.9236 7.98933C6.9236 8.41376 6.5788 8.75856 6.15437 8.75856C5.72994 8.75856 5.38514 8.41376 5.38514 7.98933C5.38514 7.5649 5.72994 7.2201 6.15437 7.2201Z"
        fill="white"
      />
      <path
        d="M11.5391 12.0098C11.5391 13.2824 12.5742 14.3175 13.8468 14.3175C15.1193 14.3175 16.1544 13.2824 16.1544 12.0098C16.1544 10.7373 15.1193 9.70215 13.8468 9.70215C12.5742 9.70215 11.5391 10.7373 11.5391 12.0098ZM13.8468 11.2406C14.2712 11.2406 14.616 11.5854 14.616 12.0098C14.616 12.4343 14.2712 12.7791 13.8468 12.7791C13.4223 12.7791 13.0775 12.4343 13.0775 12.0098C13.0775 11.5854 13.4223 11.2406 13.8468 11.2406Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_3890_88248">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

export default SvgRatioIcon
